import React from 'react';
// Import assets
import LogoSrc from '../svg/logo.svg';

export default function Logo() {
    return <img style={{maxHeight: "20px"}} src={LogoSrc} alt="Logo" />;
}
